<div class="content">
  <img class="logo logo-light" src="assets/lfw-logo-default.png" title="LiveFORMS-Web" alt="LiveFORMS.web Logo" />
  <img class="logo logo-dark" src="assets/lfw-logo.png" title="LiveFORMS-Web" alt="LiveFORMS.web Logo" />

  <dl class="versions">
    <dt>{{ 'ABOUT.APP_VERSION' | translate }}</dt>
    <dd>{{ appVersion }}</dd>
    <dt>{{ 'ABOUT.API_VERSION' | translate }}</dt>
    <dd>{{ apiVersion }}</dd>
  </dl>

  @if (hasServerInfo) {
    <div class="server-info">{{ serverInfo }}</div>
  }

  @if (hasImprint || hasPrivacy) {
    <div class="links">
      @if (hasImprint) {
        <a [href]="urlImprint">{{ textImprint }}</a>
      }
      @if (hasPrivacy) {
        <a [href]="urlPrivacy">{{ textPrivacy }}</a>
      }
    </div>
  }
</div>
